import styled from 'styled-components';
import theme from 'src/theme/Theme';

const variantWiseTextColor = {
  normal: theme.colors.NEUTRAL_HIGH,
  warning: theme.colors.PATIENT_NAV_HIGH,
  success: theme.colors.SUCCESS_HIGH,
  alarm: theme.colors.RED_TCM_FORE_COLOR,
};

export const EncounterTimeLineStyle = {
  container: {
    overflowY: 'scroll',
    padding: '30px 24px 30px 24px',
    border: '1px solid #d5d8dd',
    backgroundColor: '#FAFBFB',
    gap: '12px',
  },
  headerContainer: {
    alignItems: 'center',
    gap: '10px',
  },
  timeLineContainer: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  heading: {
    fontSize: '16px',
    fontFamily: 'Inter-SemiBold',
    lineHeight: '20px',
    color: '#000',
  },
  EncounterItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  EncounterItemStyle: {
    alignItems: 'center',
    gap: '8px',
  },
  text: {
    color: '#52525B',
    cursor: 'pointer',
  },
  textSelected: {
    color: '#2563EB',
    cursor: 'pointer',
  },
};

export const TaskTitle = styled.div`
  font-size: 12px;
  color: ${({variant}) => variantWiseTextColor[variant]};
`;
